module.exports = {"title":"User account","button.close":"Close"}